// Aceptación de la cotización por el CLIENTE, desde el enlace del correo.
// Rutas PÚBLICAS: no dependen de la sesión, y el token de la URL es la única
// credencial. Ver `api/app/Http/Controllers/Api/AceptacionPublicaController.php`.

import { apiFetch } from "@/lib/api";
import type { PayloadFacturacion } from "@/lib/portalPublico";

/**
 * Lo que la pantalla pública muestra del presupuesto.
 *
 * Es a propósito MÁS CHICO que `Cotizacion`: solo lo que el cliente ya recibió
 * por correo. Nada de ids internos, estados del proceso ni responsables — el
 * backend tampoco los manda, y este tipo es el que hace notar si algún día
 * empiezan a llegar.
 */
export interface CotizacionParaAceptar {
  cliente: string | null;
  propiedad: string | null;
  /** Ya formateado con su unidad ("76 UF"): la unidad es UF, nunca pesos. */
  precio_uf: string;
  /**
   * El PLAZO en palabras CON su disparador ("15 días hábiles a contar de la
   * visita de inspección"), no una fecha.
   *
   * Viene con la coletilla y no pelado porque es lo que imprime el PDF que el
   * cliente tiene abierto al lado, y porque sin ella el plazo se lee como si
   * arrancara con el clic que está por dar. No arranca: lo dispara la visita a
   * terreno, que necesita antes los antecedentes.
   */
  plazo: string | null;
  /** Vigencia de la oferta ("30 días"). */
  validez: string;
  /** Hasta cuándo sirve ESTE enlace, en ISO. */
  expira_en: string | null;
}

export async function fetchCotizacionParaAceptar(token: string): Promise<CotizacionParaAceptar> {
  const respuesta = await apiFetch<{ data: CotizacionParaAceptar }>(
    `/api/aceptacion/${encodeURIComponent(token)}`,
  );
  return respuesta.data;
}

/**
 * La respuesta a "¿Requieres factura?" que viaja CON la aceptación. Con "sí",
 * los datos de facturación (mismas reglas que el portal); con "no", nada más:
 * una boleta no necesita datos.
 */
export type PayloadDeAceptacion =
  | { requiere_factura: false }
  | ({ requiere_factura: true } & PayloadFacturacion);

/**
 * El cliente acepta, y en el mismo acto contesta si requiere factura.
 *
 * UNA sola petición: el servidor guarda la respuesta y acepta en la misma
 * transacción, así que no puede quedar una cotización aceptada sin la
 * respuesta ni al revés. El motivo no se pide: el acto del cliente ES la
 * evidencia.
 */
export async function aceptarConEnlaceRequest(
  token: string,
  payload: PayloadDeAceptacion,
): Promise<{ message: string }> {
  return apiFetch<{ message: string }>(`/api/aceptacion/${encodeURIComponent(token)}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
